import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_75: FaireProductEntity = {
  token: "legacy_prod_abbott-75",
  type: "product",
  name: "Multi Dogs Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/449d798ab5e651d07c7e73209dd6a967a541af8786730adf58849964dbe57b3b.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
